import { EditorView } from "codemirror";

/** Light IDE theme shared by read-only code previews and the student editor. */
export const readOnlyPythonEditorTheme = EditorView.theme(
  {
    "&": {
      backgroundColor: "#fffcf7",
      color: "#1a1a1b",
    },
    ".cm-scroller": {
      fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace',
      fontSize: "0.88rem",
      lineHeight: 1.5,
    },
    ".cm-content": {
      caretColor: "transparent",
    },
    ".cm-gutters": {
      backgroundColor: "rgba(27, 77, 46, 0.06)",
      color: "rgba(27, 77, 46, 0.55)",
      borderRight: "1px solid rgba(27, 77, 46, 0.12)",
    },
    ".cm-activeLineGutter": {
      backgroundColor: "rgba(107, 163, 54, 0.1)",
    },
    ".cm-activeLine": {
      backgroundColor: "rgba(107, 163, 54, 0.06)",
    },
  },
  { dark: false }
);
